import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal, effect } from '@core/signal.js'

define('PromoHero', () => {
    const current = signal(0)
    const root = h('section', { className: 'promo-hero' })

    function shuffle(arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]]
        }
        return arr
    }

    fetch(`/data/promos.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            const items = shuffle((data.items || []).filter(p => p.enabled !== false))
            if (!items.length) return

            const maxIndex = items.length - 1

            const track = h('div', { className: 'promo-hero__track' })
            items.forEach(item => {
                const href = `/promociones/${item.id}`
                const label = item.title || item.discount || 'Ver promocion'
                track.appendChild(
                    h('a', { className: 'promo-hero__slide', href },
                        h('img', {
                            src: item.image,
                            alt: label,
                            className: 'promo-hero__img'
                        }),
                        h('div', { className: 'promo-hero__overlay' },
                            h('span', { className: 'promo-hero__tag' }, item.tag),
                            h('p', { className: 'promo-hero__business' }, item.business),
                            h('p', { className: 'promo-hero__label' }, label),
                            h('span', { className: 'promo-hero__cta' }, 'Ver promocion →')
                        )
                    )
                )
            })

            effect(() => {
                track.style.transform = `translateX(-${current.get() * 100}%)`
            })

            const dots = h('div', { className: 'promo-hero__dots' })
            const dotEls = items.map((_, i) => {
                const dot = h('button', {
                    className: 'promo-hero__dot',
                    type: 'button',
                    'aria-label': `Ir a promo ${i + 1}`
                })
                dot.addEventListener('click', () => current.set(i))
                dots.appendChild(dot)
                return dot
            })
            effect(() => {
                dotEls.forEach((d, i) =>
                    d.classList.toggle('promo-hero__dot--active', i === current.get())
                )
            })

            const btnPrev = h('button', {
                className: 'promo-hero__arrow promo-hero__arrow--prev',
                type: 'button', 'aria-label': 'Anterior'
            }, '‹')
            const btnNext = h('button', {
                className: 'promo-hero__arrow promo-hero__arrow--next',
                type: 'button', 'aria-label': 'Siguiente'
            }, '›')

            btnPrev.addEventListener('click', () =>
                current.set(Math.max(0, current.get() - 1))
            )
            btnNext.addEventListener('click', () =>
                current.set(Math.min(maxIndex, current.get() + 1))
            )

            effect(() => {
                btnPrev.disabled = current.get() === 0
                btnNext.disabled = current.get() === maxIndex
            })

            root.appendChild(
                h('div', { className: 'promo-hero__viewport' },
                    btnPrev,
                    h('div', { className: 'promo-hero__window' }, track),
                    btnNext
                )
            )
            root.appendChild(dots)

            let autoplay = setInterval(() => {
                const next = current.get() + 1
                current.set(next > maxIndex ? 0 : next)
            }, 5000)

            root.addEventListener('mouseenter', () => clearInterval(autoplay))
            root.addEventListener('mouseleave', () => {
                autoplay = setInterval(() => {
                    const next = current.get() + 1
                    current.set(next > maxIndex ? 0 : next)
                }, 5000)
            })
        })
        .catch(() => {})

    return root
})
